<template>
  <div class="box" style="position:relative;">
    <div class="overlay" v-if="showSpinner">
      <i class="fa fa-spinner fa-spin"></i>
    </div>    
    <div class="table-responsive">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th>Fecha</th>
            <th>Cliente</th>
            <th>Proyecto</th>
            <th>Acciones</th>
          </tr>
          <tr v-for="(item,index) in registros" :key="item.id">
            <td>{{ fechaReporte(item.fecha) }}</td>
            <td>{{ item.cliente_empresa }}</td>
            <td>{{ item.codigo_proyecto }}</td>
            <td>
              <template v-if="solapa !== 'archivo'">
                <a href="javascript:void(0)" class="btn btn-xs text-info" @click="acciones('ver', item, index)"><i class="fa fa-eye"></i> Ver</a>
                <a href="javascript:void(0)" class="btn btn-xs text-warning" v-if="puedoEditar" @click="acciones('editar', item, index)"><i class="fa fa-edit"></i> Editar</a>
                <a href="javascript:void(0)" class="btn btn-xs text-danger" v-if="puedoEditar" @click="acciones('archivar', item, index)"><i class="fa fa-archive"></i> Archivar</a>
              </template>
              <template v-else>
                <a href="javascript:void(0)" class="btn btn-xs text-info" @click="acciones('ver', item)"><i class="fa fa-eye"></i> Ver</a>
                <a href="javascript:void(0)" class="btn btn-xs text-danger" v-if="puedoEditar" @click="acciones('desarchivar', item, index)"><i class="fa fa-archive"></i> Desarchivar</a>                
              </template>
            </td>
          </tr>
        </tbody>
      </table>                            
    </div>
    <paginate
      v-show="paginado.total > 0"
      v-model="paginado.pagina_actual"
      :page-count="paginado.paginas"
      :click-handler="cambiarPagina"
      :prev-text="'<'"
      :next-text="'>'"       
      :container-class="'pagination pagination-sm'"
    >
    </paginate>    
  </div>
</template>
<script>
import {capitalize} from '../../../filters/string'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
require('moment/locale/es')

export default {
  name: 'TablaParteDiario',
  components: {
    Paginate
  },
  filters: {
    capitalize
  },
  props: {
    solapa: {
      type: String,
      default () {
        return 'partes'
      }
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    },
    regPagina: {
      type: Number,
      default: 10
    },
    puedoEditar: {
      type: Boolean,
      default: false
    },
    paginaActual: {
      type: Number,
      default: 0
    },
    cargando: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showSpinner: this.cargando,
      registros: this.data,
      paginado: {
        total: 0,
        paginas: 1,
        pagina_actual: this.paginaActual,
        reg_pagina: this.regPagina
      }
    }
  },
  mounted () {
  },
  methods: {
    cambiarPagina (pag) {
      this.$emit('partes:filtar', pag, this.solapa)
    },
    fechaReporte (fecha) {
      let _fecha = typeof fecha === 'string' ? moment(fecha.replace('Z', '')) : moment(fecha)
      return _fecha.get('D') + ' ' + this.$options.filters.capitalize(moment.months()[_fecha.month()])
    },
    acciones (nombre, item, index) {
      this.$emit('partes:acciones', nombre, item, index, this.solapa)
    }
  },
  watch: {
    data: function (a) {
      this.registros = a
    },
    total: function (a) {
      this.paginado.total = a
      this.paginado.paginas = Math.ceil(a / this.paginado.reg_pagina)
    },
    regPagina: function (a) {
      this.paginado.reg_pagina = a
    },
    paginaActual: function (a) {
      this.paginado.pagina_actual = a
    },
    cargando: function (a) {
      this.showSpinner = a
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/partes-diarios/TablaParteDiario.vue